<template>
  <TolModal
    :title="$t('projects.eventTypes.details.tools.add')"
    :submit-button-text="$t('projects.details.labels.save')"
    @close="clearFormAndClose"
    @submit="save"
  >
    <template v-slot:body>
      <form>
        <div class="form-group">
          <div class="form-control">
            <div>
              <label>
                {{ $t('projects.eventTypes.details.tools.name') }}
                <span class="asterisk">*</span>
              </label>
              <DropdownSelect
                :menu-items="tools"
                :selected-item="addNewOptionEnabled ? $t('dropdown.newItem') : tool.name"
                :disabled="addNewOptionEnabled"
                class="bordered"
                add-new-option-enabled
                @select-item="selectTool"
                @add-new="addNewTool"
              />
            </div>
            <div v-if="addNewOptionEnabled" class="new-tool-container">
              <label>
                {{ $t('projects.eventTypes.details.tools.newToolName') }}
                <span class="asterisk">*</span>
              </label>
              <InputField
                v-model="tool.name"
                type="text"
                class="bordered"
                :class="{ error: formErrors['name'] }"
                picker="minus-circle"
                @input="tool.name = $event"
                @picker-click="tool.name = ''"
              />
            </div>
          </div>
          <div class="form-control">
            <label>
              {{ $t('projects.eventTypes.details.tools.comments') }}
            </label>
            <TolTextArea
              v-model="tool.comments"
              class="form-textarea"
              @change="tool.comments = $event.target.value"
            />
          </div>
        </div>
      </form>
    </template>
  </TolModal>
</template>

<script>
import DropdownSelect from '@/app/components/DropdownSelect';
import InputField from '@/app/components/InputField';
import TolModal from '@/app/components/TolModal';
import TolTextArea from '@/app/components/TolTextArea';

export default {
  name: 'AddToolModal',
  components: {
    DropdownSelect,
    InputField,
    TolModal,
    TolTextArea
  },
  props: {
    tools: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      tool: {
        id: '',
        name: '',
        comments: ''
      },
      addNewOptionEnabled: false
    };
  },
  computed: {
    formErrors() {
      return this.$store.getters.ProjectEventTypeToolsValidationErrors;
    }
  },
  methods: {
    clearFormAndClose() {
      this.tool = {
        name: '',
        comments: ''
      };
      this.$emit('close');
    },
    addNewTool() {
      this.tool.id = '';
      this.tool.name = '';
      this.addNewOptionEnabled = true;
    },
    selectTool(event) {
      this.addNewOptionEnabled = false;
      this.tool.id = event.id;
      this.tool.name = event.name;
    },
    async save() {
      const payload = {
        field: 'tools',
        type: 'TOOLS',
        value: this.tool
      };
      this.$emit('save', payload);
    }
  }
};
</script>

<style scoped lang="scss">
.form-group > div {
  margin-bottom: 1rem;
}

.new-tool-container {
  margin-top: 1rem;
}

.form-textarea {
  min-width: 30rem;
}

.asterisk {
  color: red;
}
</style>
